import type { FormQuestion } from "@/components/features/FormBuilder/types/form.types";

export function isBlankAnswer(value: unknown, type?: FormQuestion["type"]): boolean {
  if (value === undefined || value === null) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return value === false && type === "acknowledgement";
}
